import { Component, AfterContentInit, OnDestroy } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import {
  ProcedureDTO,
  DossierDTO,
  getSimpleIdentifierFromString,
  DivisionDTO,
  DocumentDTO,
  DocumentClassDTO,
  MasterDataDTO,
  StartInfo
} from '../../api/plyca-dtos';
import { RuleDTO, CircuitoDTO, StepCircuitoDTO, CircuitFilterModeDTO } from '../../api/plyca-dtos-v2';
import { PaginationDTO } from '../../api/PaginationModel';
import { Configuration } from '../../conf/app.constants';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import { DataRetrieverConfig, FieldConfig } from '../../api/contract-notice-dto';
import { DossierService } from '../dossier.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { TranslateService } from '@ngx-translate/core';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { SelectItem, TreeNode, MenuItem } from 'primeng-lts/api';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { catchError, finalize, switchMap, take } from 'rxjs/operators';
import { PropertyService } from '../../properties/property.service';
import { AppConfiguration } from '../../conf/app.configuration';
import { UserService } from '../../user.service';


class ModelDTO {
  flujoId: string;
  division: DivisionDTO;
  circuito: CircuitoDTO;
  tipoDocumento: DocumentClassDTO;
  comment: string;

  isValid(): boolean {
    return (
      this.division !== undefined &&
      this.circuito !== undefined &&
      this.tipoDocumento !== undefined
    );
  }
}

@Component({
  selector: 'procedure',
  templateUrl: 'procedure.template.html',
  providers: [DialogService]
})
export class procedureComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  model: ModelDTO;

  // division: DivisionDTO;
  dossier: DossierDTO;
  // divisiones: DivisionDTO[];
  tagsParent: string[] = [];

  circuitos: SelectItem[];
  rootDivision: TreeNode[];
  dossierId = 'Sin Información';
  loaded = false;

  rule: RuleDTO;
  document: DocumentDTO;
  procedure: ProcedureDTO;

  windowHash: string;

  allCircuits = false;

  items: MenuItem[];

  optionLoadAll = '';

  showCircuits = true;

  showPhase = false;
  selectedPhase: MasterDataDTO;

  phaseSearchId: string;
  availablePhases: Array<any> = [];

  constructor(
    public plycaService: PlycaDataService,
    public dossierService: DossierService,
    public headerActionsService: HeaderActionsService,
    public helpService: HelpService,
    public uiService: UIService,
    protected waitService: WaitLoadingService,
    private ref: DynamicDialogRef,
    public configuration: Configuration,
    public config: DynamicDialogConfig,
    private plycaErrorHandler: PlycaErrorHandler,
    public propertyService: PropertyService,
    protected translate: TranslateService,
    private appConfig: AppConfiguration,
    public userService: UserService
  ) {
    super();
    this.model = new ModelDTO();




    this.subscribe(this.helpService.getStoreTagsObservable().pipe(
      switchMap(
        (storedHelpTags) => {
          this.tagsParent = storedHelpTags;
          return this.helpService.showContextHelpObservable(HelpType.ADD_PROCEDURE)
        }
      )));


    // si la llamada viene de un dialog
    //      this.dossierId = this.config.dossierId;
    this.rule = this.config['rule'];
    this.dossier = this.config['dossier'];
    this.document = this.config['document'];

    this.phaseSearchId = this.appConfig.getValueByDossierType(this.dossier.division.documentClass.application, 'documentoManual.phases.search');

    this.optionLoadAll = this.translate.instant('Procedures.loadAllCircuits');

    let stShowCircuits = this.propertyService.instant('NUEVO_TRAMITE_MOSTRAR_CIRCUITOS', 'true');
    this.showCircuits = stShowCircuits == null || stShowCircuits == undefined || stShowCircuits.trim().toLocaleLowerCase() !== 'false';

    // HACK HASTA SOLUCIONAR EL PROBLEMA DE LAS DIVISIONES
    //    this.division = this.rule.division;
    //    this.divisiones = this.config['divisiones'];
    //    this.divisiones = [];
    // console.log('PROCEDURE.COMPONENT: DIVISIONES->', this.config['divisiones']);
    // route.params.subscribe(params => {
    //   this.dossierId = params['id'];
    // });

    // this.userService = ServiceLocator.injector.get(UserService);
    // this.uiService = ServiceLocator.injector.get(UIService);
  }

  ngAfterContentInit(): void {
    this.windowHash = generateRandomIdentifier();
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'Tramitar',
        'fas fa-lg fa-check',
        'btn-primary',
        true,
        this.windowHash
      ),
      () => {
        this.process();
      });
    this.headerActionsService.addWindowDivider(this.windowHash);
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.close',
        'fas fa-lg fa-times',
        'btn-outline-secondary',
        true,
        this.windowHash
      ),
      () => {
        this.cancel();
      });
    this.load();
  }

  ngOnDestroy(): void {
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {

        this.headerActionsService.clearWindowActions(this.windowHash);
        this.config = null;
        this.ref = null;

        super.ngOnDestroy();
      })));

  }


  public isLoaded() {
    return this.loaded;
  }

  load() {
    this.loaded = true;
    this.subscribe(this.dossierService
      .getDivisionsTree(this.dossier.identifier),
      rootNode => {
        this.rootDivision = [];
        this.rootDivision.push(this.division2Node(rootNode));
        console.log('divisiones', this.rootDivision);
        this.loaded = true;
      });

    // si llega regla hay que recargarla y extraer lo necesario de la propia regla
    if (this.rule) {
      this.subscribe(this.plycaService
        .get<RuleDTO>(
          this.configuration.RULES_SERVICE_URL,
          this.rule.identifier
        ),
        _rule => {
          this.rule = _rule;
          this.procedure = _rule.procedure;
          this.selectCircuito(_rule.procedure.circuit);
          this.loaded = true;
        });
    } else if (this.document) {
      this.model.division = this.document.entity.division;
      this.model.tipoDocumento = this.document.entity.documentClass;
      if (this.showCircuits) {
        this.loadCircuitos();
      }
    } else {
      // let d = <DocumentClassDTO>{ identifier: '00170' };
      // this.model.tipoDocumento = d;
    }
  }
  private loadCircuitos(all?: boolean) {
    let mode = CircuitFilterModeDTO.Extension;
    if (all) {
      mode = CircuitFilterModeDTO.Mandatory;
    }
    this.circuitos = [];
    // 1. Cargar circuitos
    this.subscribe(this.plycaService
      .getCircuitos(
        this.dossier.identifier,
        getSimpleIdentifierFromString(this.model.division.identifier),
        getSimpleIdentifierFromString(this.model.tipoDocumento.identifier),
        mode,
        this.document?.entity?.orderNumber
      ),
      (param: PaginationDTO<CircuitoDTO>) => {
        if (param != null && param.content) {
          param.content.forEach(item =>
            this.circuitos.push({ label: item.name, value: item })
          );
          if (this.circuitos.length > 0) {
            this.selectCircuito(this.circuitos[0].value);
          }

          if (!all) {
            this.circuitos.push({ label: '_____________________________', disabled: true, value: undefined });
            this.circuitos.push({ label: this.optionLoadAll, value: undefined });
          }
        } else {
          // si se han intentado cargar los mandatory y no hay, cargamos todos
          if (!all) {
            this.loadCircuitos(true);
          }
        }
        this.loaded = true;
      });
  }

  selectDocumentClass() {
    this.model.division = undefined;
    this.circuitos = [];
  }

  selectDivision() {
    if (this.model.division && this.model.division['executionStatus'] == 'PAUSED') {
      this.model.division = null;
      this.uiService.showMessage(this.translate.instant('Procedures.divisionPaused'));
    } else {
      // Si funcionamos en modo sin circuitos, nos ahorramos la carga
      if (this.showCircuits) {
        this.loadCircuitos();
      } else if (this.phaseSearchId !== undefined) {
        this.searchPhasesOfDivision();
      }
    }
  }

  division2Node(division: DivisionDTO): TreeNode {
    // hack para la descripcion en el tree
    //    division['description'] = division.name;
    let divisionNode: TreeNode = {
      data: division,
      expanded: true,
      label: division.name
      // children: this.children2Nodes(division)
    };
    divisionNode['children'] = this.children2Nodes(division);
    //    division['icono'] = icon;
    return divisionNode;
  }

  children2Nodes(divisionNode: DivisionDTO) {
    let _children = [];
    if (divisionNode.children) {
      divisionNode.children.forEach(child => {
        let tmp = this.division2Node(child);
        _children.push(tmp);
      });
    }
    return _children;
  }

  selectCircuito(_circuito: CircuitoDTO) {
    console.log('SELECCIONANDO CIRCUITO: ', _circuito);
    this.model.circuito = this.circuitos.find(item => {
      console.log(
        'BUSCANDO CIRCUITO: ',
        item.value.identifier,
        _circuito.identifier
      );
      return item.value.identifier === _circuito.identifier;
    }).value;
    console.log('CIRCUITO seleccionado: ', this.model.circuito);
    this.loadSteps(_circuito);
  }

  loadSteps(_circuito: any) {
    if (_circuito === undefined || this.optionLoadAll === _circuito.label) {
      // Solo debe entrar por aqui con la opcion de cargar todos los circuitos
      this.loadCircuitos(true);
    } else {
      this.model.circuito = _circuito;
      let itemsTmp: MenuItem[] = [];
      if (this.model?.circuito?.config?.listCircuitStepDTO) {
        this.model.circuito.config.listCircuitStepDTO.forEach(step => {
          itemsTmp.push({ label: step.typeStep });
        });
      }
      this.items = itemsTmp;
    }
  }

  /*
   * ACCIONES (PROCESAR O CANCELAR)
   */

  process() {
    if (!this.model.tipoDocumento || !this.model.division
      || (this.showCircuits && !this.model.circuito)) {
      return;
    }

    this.waitService.startWaiting();
    // Se deben informar los valores obligatorios del objeto
    // ProcedureDTO:
    //   identifier.parent.identifier
    //   documentClass.identifier
    //   definition.identifier
    //   typeProcedure
    //   circuit.identifier
    //   phase

    let _procedure = <ProcedureDTO>{};
    _procedure.documentClass = this.model.tipoDocumento;
    _procedure.division = this.model.division;

    _procedure.circuit = this.model.circuito;
    if (this.selectedPhase !== undefined) {
      _procedure.phase = this.selectedPhase;
    }
    if (this.model.comment !== undefined) {
      _procedure.startInfo = <StartInfo>{};
      _procedure.startInfo.comment = this.model.comment;
    }

    let url = this.configuration.PROCEDURES_SERVICE_URL.replace(
      '{dossierId}',
      this.dossier.identifier
    );
    this.subscribe(this.plycaService.insert<ProcedureDTO>(url, _procedure),
      response => {
        let message = this.translate.instant('Procedures.procedureStarted') + ' ' + response.description;
        if (this.userService.hasRoles('50')) {
          message += ' (' + getSimpleIdentifierFromString(response.identifier) + ')';
        }
        this.uiService.showMessage(message);
        this.ref.close(response);
      },
      error => {
        this.plycaErrorHandler.showServerError(error).onClose.pipe(take(1)).subscribe(() => this.ref.close());
      }
    );
  }

  cancel() {
    this.ref.close();
  }

  public getBuscadorDocumentos(): FieldConfig {
    let config = new FieldConfig();
    config.type = 'SEARCH';
    config.jsonField = 'tipoDocumento';
    config.description = this.translate.instant('Procedures.selectDocument');
    config.fieldStyle = 'plForm-element';
    config.autoSearch = false;
    //    config.idBuscador = 'DOCUMENTCLASSFLOW';
    //config.idBuscador = 'DOCUMENTCLASS';
    config.onChangeFunction = this.selectDocumentType.bind(this);
    config.editable = !this.document?.entity?.orderNumber;
    let value = null;
    try {
      // let dossierConfig = this.appConfig.getValue('dossierConfig');
      // value = dossierConfig[this.dossier.division.documentClass.application]['documentoManual.documentClassSearch'];
      value = this.appConfig.getValueByDossierType(this.dossier.division.documentClass.application, 'documentoManual.documentClassSearch');
    } catch { }
    if (value == null || value === '') {
      value = 'DOCNOESTRUC_OBJPORFLUJO';
    }
    config.idBuscador = value;
    // });
    if (this.dossier && this.dossier.division) {
      config.parameters = [{
        'identifier': 'OBJPORFLUJO.LISTADOCID', 'value': '\''
          + this.dossier.division.documentClass.identifier + '\''
      }, {
        'identifier': 'OBJPORFLUJO.PROCONTRID', 'value': '\''
          + getSimpleIdentifierFromString(this.dossier.division.procedure.identifier) + '\''
      }];
    }
    return config;
  }

  public selectDocumentType() {
    this.loadCircuitos();
  }

  public getBuscadorBuzonesConfig(step: StepCircuitoDTO): FieldConfig {
    let config = new FieldConfig();
    config.type = 'SEARCH';
    config.jsonField = 'inbox';
    config.description = '';
    config.autoSearch = true;
    config.idBuscador = 'INBOX';

    config.parameters = [
      { 'identifier': 'PERFILBUZON.PERID', 'value': '' + step.profile.identifier },
      { 'identifier': 'BUZON.USUARIOSNOBLOQUEADOS', 'value': 'true' },
      {
        'identifier': 'PERFILBUZON.APLICACION', 'value': this.dossier && this.dossier.division && this.dossier.division.documentClass
          && this.dossier.division.documentClass.application ? '\'' + this.dossier.division.documentClass.application + '\'' : "'CONTRATACION'"
      },
      { 'identifier': 'ORGANISMO.RUTA', 'value': this.dossier.division.project.organizationalUnit }
    ];

    return config;
  }

  public getBuscadorDivisionTree(): FieldConfig {
    let config = new FieldConfig();
    config.type = 'DIVISION';
    config.jsonField = 'division';
    config.description = this.translate.instant('Procedures.selectDivision');
    config.fieldStyle = 'plForm-element';
    config.idBuscador = this.dossier.identifier;
    config.editable = !this.document?.entity?.orderNumber;
    return config;
  }

  // public getFieldConfigCircuitos(): FieldConfig {
  //   let config = new FieldConfig();
  //   config.type = 'SELECT';
  //   config.jsonField = 'circuito';
  //   config.description = '3. Seleccionar circuito de tramitación';
  //   config.fieldStyle = 'plForm-element';
  //   // config.idBuscador = this.dossier.identifier;
  //   return config;
  // }


  public getBuscadorFaseConfig(): FieldConfig {


    let config = new FieldConfig();
    config.type = 'DROPDOWN';
    config.jsonField = 'selectedPhase';
    config.description = this.translate.instant('BasicDocument.fase');
    config.fieldStyle = 'plForm-element';
    let divId = this.model.division?.identifier;
    config.editable = divId !== undefined;
    config.dataConfig = new DataRetrieverConfig();
    config.dataConfig.jsonPath = 'availablePhases';
    config.dinamicOptionsActive = true;
    config.orderByDescription = false;
    config.showClearOption = false;

    config.editable = true;
    return config;
  }

  searchPhasesOfDivision() {

    let searchUrl = this.configuration.SEARCH_SETTINGS_SERVICE_URL + this.phaseSearchId + '/values?';

    searchUrl += 'PROPUESTAID' + '=' + this.dossier.identifier;
    searchUrl += '&';
    searchUrl += 'DIVISION' + '=' + this.model.division?.identifier;

    this.subscribe(this.plycaService
      .query<any>(searchUrl)
      .pipe(
        catchError(
          () =>
            (this.availablePhases = [])
        )
      ),
      (s: PaginationDTO<any>) => {
        this.availablePhases = [];
        if (s.content) {
          this.selectedPhase = this.model.division?.phase;
          s.content.map((data) => {
            this.availablePhases.push(data.singleValue);
          });

        }
      });
  }
}
